import { COUNTRY_CODES } from '../../utils/countryCodes';

const inputClass =
  'w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm transition focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/20';

const labelClass = 'mb-1.5 block text-sm font-medium text-slate-700';

export default function PhoneFields({
  idPrefix,
  countryCode,
  phone,
  onCountryCodeChange,
  onPhoneChange,
  message,
  onMessageChange,
  showMessage = false,
}) {
  return (
    <div className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-[140px_1fr]">
        <div>
          <label htmlFor={`${idPrefix}-country`} className={labelClass}>
            Country code
          </label>
          <select
            id={`${idPrefix}-country`}
            className={inputClass}
            value={countryCode}
            onChange={(e) => onCountryCodeChange(e.target.value)}
          >
            {COUNTRY_CODES.map(({ value, label }) => (
              <option key={value || 'empty'} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor={`${idPrefix}-phone`} className={labelClass}>
            Phone number
          </label>
          <input
            id={`${idPrefix}-phone`}
            type="tel"
            className={inputClass}
            placeholder="600 00000"
            value={phone}
            onChange={(e) => onPhoneChange(e.target.value)}
          />
        </div>
      </div>
      {showMessage && (
        <div>
          <label htmlFor={`${idPrefix}-message`} className={labelClass}>
            Message
          </label>
          <textarea
            id={`${idPrefix}-message`}
            rows={4}
            className={inputClass}
            placeholder="SMS message"
            value={message}
            onChange={(e) => onMessageChange(e.target.value)}
          />
        </div>
      )}
    </div>
  );
}


